<template>
  <div>
    <div class="page-title">新申請 New Admission</div>
    <div class="application-detail">
      <div
        style="white-space: pre-wrap;"
        v-if="applicationDetail.eventStatus"
        class="fs-title"
      >
        {{ applicationDetail.eventStatus.title }}
      </div>
      <div class="application-content">
        <applicationView v-if="applicationDetail" :id="id" :type="formType" :studentPerformance="studentPerformance" :studentFiles="studentFiles" :declaration="declaration" :parentParticularData="parentParticularData" :personalBackground="personalBackground" :studentParticular="studentParticular" :isView="true" :applicationDetail="applicationDetail"></applicationView>
        <el-button @click="onBack" type="primary"> Back </el-button>
      </div>
      <copyrightCard></copyrightCard>
    </div>
  </div>
</template>

<script>
import applicationFormat from "@/utils/applicationFormat";
import {
  getApplicationDetail,
} from "@/api/admin/application";
import applicationView from '@/components/applicationView'
import copyrightCard from '@/components/copyrightCard'
export default {
  mixins: [applicationFormat],
  components:{applicationView,copyrightCard},
  props: {
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      applicationDetail: {},
      applicationId: 0,
      formType: 0,
    };
  },
  created(){
    this.int()
  },
  methods: {
    int() {
      this.formType = this.type;
      this.applicationId = this.id;
      this.isEditGetApplicationDetail();
    },
    isEditGetApplicationDetail() {
      getApplicationDetail(this.applicationId).then((v) => {
        this.applicationDetail = v.data;
        this.studentParticular = JSON.parse(
          this.componentMethods(v.data.components, 0)
        );
        this.parentParticularData.parentParticulars = JSON.parse(
          this.componentMethods(v.data.components, 1)
        );
        this.personalBackground = JSON.parse(
          this.componentMethods(v.data.components, 2)
        );
        this.studentFiles = JSON.parse(
          this.componentMethods(v.data.components, 3)
        );
        this.questionnaire.questionnaires = JSON.parse(
          this.componentMethods(v.data.components, 4)
        );
        this.applicantLanguage.applicantLanguages = JSON.parse(
          this.componentMethods(v.data.components, 5)
        );
        this.subjectsApplied = JSON.parse(
          this.componentMethods(v.data.components, 6)
        );
        this.declaration = JSON.parse(
          this.componentMethods(v.data.components, 7)
        );
        this.studentPerformance = JSON.parse(
          this.componentMethods(v.data.components, 8)
        );
        this.$forceUpdate();
      });
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0].value;
    },
    onBack() {
      this.$router.push({ path: `/parent/application` });
    },
  },
};
</script>

<style lang="scss" scoped>
.application-detail {
  background-color: #fff;
  padding-top: 60px;
}
.application-content {
  padding: 0 60px;
}
.el-breadcrumb {
  margin: 30px 0;
}
.dialog-title {
  font-size: 20px;
}
.dialog-text {
  font-size: 16px;
}
::v-deep {
  .el-breadcrumb__item:first-child .el-breadcrumb__inner {
    color: #0064ed;
  }
  .el-button--primary {
    width: auto;
    background-color: #0962fa;
    border-color: #0962fa;
    font-size: 20px;
    font-weight: bold;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .application-content{
    padding: 0 0.625rem;
  }
}
</style>